// extracted by mini-css-extract-plugin
export default {"howToPage":"styles_howToPage__ibSyr","howToPageContainer":"styles_howToPageContainer__wstnX","howToPageContent":"styles_howToPageContent__BXoqr","fadeIn":"styles_fadeIn__nLVFd"};